import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FieldConfig } from "../../models/field.interface";
import { NgxImageCompressService } from 'ngx-image-compress';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DeleteImageComponent } from '../../../delete-image/delete-image.component';
import * as _ from 'lodash';
import { ValidationService, ValidationType } from '../../services/validation.service';
import { DomSanitizer } from '@angular/platform-browser';
import * as moment from 'moment';
import * as Compress from 'compress.js';
import { ImagePreviewComponent } from '../../../image-preview/image-preview.component';
@Component({
  selector: 'app-unorderedlist',
  template: `
<div [formGroup]="group">
  <div class="hazard-description image-picker" *ngIf="field.style.visibility">
    <p>{{field.name}}<b *ngIf="field.validation.isRequired">*</b></p>
    <ng-container *ngIf="field.style.editability">
    <p class="max-image" *ngIf="!minimumFiveImage">You can upload max 5 images</p>
    <p class="max-image-red" *ngIf="minimumFiveImage">You can upload max 5 images</p>
    </ng-container>
    <div class="sameline-image" *ngFor='let url of field.value;let i=index'>
      <img class="img-cross" *ngIf="field.style.editability" (click)="deleteImage(i)"  src="assets/rff-images/remove-ic.svg">
      <img class="wdth-64" (click)="openImage(url.thumb)" [src]="domSanitizer.bypassSecurityTrustUrl(url.thumb)"> <br />
    </div>
    <label  class="addfile" *ngIf="field.style.editability">
      <input type="file" (change)="onSelectFile($event)" multiple accept=".png, .jpg, .jpeg" class="media-file" #inputFile>
      <img src="assets/rff-images/add-img.svg" alt="add-img.svg" style="margin:0">
      <span>Add Photos</span>
    </label>
    <span class="error-message" *ngIf="field.errorMessage !== ''">{{field.errorMessage}}</span>    
    <span class="error-message" *ngIf="showError">Uploaded Image should be less than 1 MB</span>    
  </div>
</div>
`,
  styles: [`
.sameline-image {float: left;display: inline;margin-top:13px;margin-right: 20px;}
.img-cross{position: absolute;margin: -17px 47px auto}
.opacity{opacity : 0.3 ; pointer-events:none}`],
})
export class ImagePickerComponent implements OnInit {
  field: FieldConfig;
  @ViewChild('inputFile') myInputVariable: ElementRef;
  group: FormGroup;
  minimumFiveImage = false;
  urls = [];
  popupImage = this.urls;
  deleteIndex;
  fieldArray: any;
  showError = false;
  date;
  location;
  imageSrc;
  constructor(
    private imageCompress: NgxImageCompressService,
    private modalService: NgbModal,
    private _validationService: ValidationService,
    private domSanitizer: DomSanitizer
  ) {}
  onSelectFile(event, image, orientation) {
    this.minimumFiveImage = false;
    if (event.target.files && event.target.files[0]) {
      let fileName = event.target.files[0].name;
      let filesAmount = event.target.files.length;
      if (filesAmount + this.urls.length <= 5) {
        if (filesAmount <= 5) {
          for (let i = 0; i < filesAmount; i++) {
            const compress = new Compress()
            let file = event.target.files[i];
            if (file && file.size > 1000000) {
              this.showError = true;
              return;
            } else {
              this.showError = false;
            }
            let reader = new FileReader();
            reader.onload = (event: Event) => {
              var img: any = new Image();
              img.src = reader.result;
              img.onload = () => {
                let canvas = document.createElement('canvas');
                var contex = canvas.getContext('2d');
                canvas.width = img.width;
                canvas.height = img.height;
                contex.drawImage(img, 0, 0)
                contex.font = "calc(1.2vw + 1.2vh) sans-serif";
                contex.fillStyle = "white";
                contex.fillText(this.date, 20, (img.height - 70));
                contex.fillText(this.location, 20, img.height - 30);
                this.imageCompress.compressFile(canvas.toDataURL(), 50, 50).then((result:any) => {
                  function dataURLtoFile(result, filename) {
                    var arr = result.split(','),
                      mime = arr[0].match(/:(.*?);/)[1],
                      bstr = atob(arr[1]),
                      n = bstr.length,
                      u8arr = new Uint8Array(n);
                    while (n--) {
                      u8arr[n] = bstr.charCodeAt(n);
                    }
                    return new File([u8arr], filename, { type: mime });
                  }
                  var file = dataURLtoFile(result,fileName);
                  compress.compress([file], {
                    size: 1,
                    quality: 1,
                    maxWidth: img.width,
                    maxHeight: img.height,
                    resize: false,
                  }).then((res: any) => {
                    let resultImage = res[0].prefix + res[0].data;
                    const imageData = {
                      file: file,
                      thumb: resultImage
                    }
                    if (this.field.value === undefined || this.field.value.length === 0) {
                      this.field.value = [];
                      this.urls = []
                    }
                    this.field.value.push(imageData);
                    this.urls.push({ src: resultImage, file: file, thumb: resultImage });
                    this.group.value[this.field.id] = this.field.value;
                    const data = this.group.value;
                    this._validationService.applyValidation(this.field, data, [ValidationType.isRequired, ValidationType.onChange]);
                    this.myInputVariable.nativeElement.value = '';
                  })
                });
              }
            };
            reader.readAsDataURL(file);
          };
        }
      } else {
        this.minimumFiveImage = true;
      }
    }
  }
  findMe() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.showPosition(position);
      });
    } else {
      alert("Geolocation is not supported by this browser.");
    }
  }

  showPosition(position) {
    this.date = 'Date: ' + moment().format('L') + ', Time: ' + moment(new Date()).format('LT');
    this.location = 'Location: ' + position.coords.latitude.toFixed(5) + ', ' + position.coords.longitude.toFixed(5);
  }
  ngOnInit() {
    if (this.field.value && this.field.value !== " ") {
      _.forEach(this.field.value, (thumb) => {
        if(thumb.thumb){
        thumb.src = thumb.thumb;
        this.urls.push(thumb);
        }else{
          let perviewThumb = {
            src : this.getBase64String(thumb.thumbnail),
            thumb : this.getBase64String(thumb.thumbnail),
          }
          this.urls.push(perviewThumb);
          this.field.value = this.urls;
        }
      })
    }
    if(this.field.value === undefined && this.field.value === " "){
      this.field.value = [];
    }
    this.findMe();
  }
  getBase64String(str) {
    return 'data:image/jpg;base64,' + str;
  }
  deleteImage(i) {
    let modalOptions: any = {
      size: 'md',
      centered: true,
      windowClass: 'md-dialog-small nested-modal',
    };
    const modalRef = this.modalService.open(DeleteImageComponent, modalOptions);
    modalRef.componentInstance.popupImage = this.popupImage; 
    modalRef.componentInstance.deleteIndex = i;
    modalRef.componentInstance.fieldArray = this.field.value;
    modalRef.componentInstance.title = this.field.name;
    modalRef.componentInstance.filedValueLength = (data)=>{
      this.field.value = undefined;
    };
  }
  openImage(img){
    let modalOptions: any = {
      size: 'md',
      centered: true,
      windowClass: 'md-dialog-lg light-modal',
    };
    const modalRef = this.modalService.open(ImagePreviewComponent, modalOptions);
    modalRef.componentInstance.imageSrc = img;
  }
}



// WEBPACK FOOTER //
// ./src/app/rFF/fields/imagePicker/imagePicker.component.ts